export enum Type {
  t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14,
  white, dark, danger, success, info, warning, primary, secondary, tertiary, light, link
}